module.exports = __webpack_public_path__ + "img/16.20f0b1a7.jpg";